import { render, staticRenderFns } from "./AgeDistributedFilter.vue?vue&type=template&id=47d7cf3a&scoped=true&"
import script from "./AgeDistributedFilter.vue?vue&type=script&lang=js&"
export * from "./AgeDistributedFilter.vue?vue&type=script&lang=js&"
import style0 from "./AgeDistributedFilter.vue?vue&type=style&index=0&id=47d7cf3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7cf3a",
  null
  
)

export default component.exports